/*
 * @Date: 2019-08-20 18:40:41
 * @LastEditors: x
 * @LastEditTime: 2019-08-22 14:39:56
 */
import base from './base'
import account from './account'
import pay from './pay'
import install from './install'
import ticket from './ticket'

export default {
  base,
  account,
  pay,
  install,
  ticket
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js